import { useGetList } from "ra-core";

export interface BldrOsStats {
  leadsToday: number;
  callsToday: number;
  smsToday: number;
  openContacts: number;
  isPending: boolean;
}

function todayISO(): string {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}

/**
 * Fetches high-signal KPI stats for the BldrOS dashboard.
 * All queries go through ra-core's useGetList → Supabase data provider → RLS.
 */
export function useBldrOsStats(): BldrOsStats {
  const today = todayISO();

  const { total: leadsToday, isPending: p1 } = useGetList("contacts", {
    pagination: { page: 1, perPage: 1 },
    sort: { field: "created_at", order: "DESC" },
    filter: { "created_at@gte": today },
  });

  const { total: callsToday, isPending: p2 } = useGetList("calls", {
    pagination: { page: 1, perPage: 1 },
    sort: { field: "created_at", order: "DESC" },
    filter: { "created_at@gte": today },
  });

  const { total: smsToday, isPending: p3 } = useGetList("sms_messages", {
    pagination: { page: 1, perPage: 1 },
    sort: { field: "created_at", order: "DESC" },
    filter: { "created_at@gte": today },
  });

  const { total: openContacts, isPending: p4 } = useGetList("contacts", {
    pagination: { page: 1, perPage: 1 },
    sort: { field: "created_at", order: "DESC" },
    filter: { "status@in": "(new,contacted,qualified)" },
  });

  return {
    leadsToday: leadsToday ?? 0,
    callsToday: callsToday ?? 0,
    smsToday: smsToday ?? 0,
    openContacts: openContacts ?? 0,
    isPending: p1 || p2 || p3 || p4,
  };
}
